import styled from "styled-components";

export const NoData = styled.div`
  text-align: center;
  padding-top: 24px;
`;

export const Table = styled.div`
  display: grid;
  grid-template-columns: 45% 10% 10% 15% 15% 10%;

  width: 100%;
  border-bottom: 1px solid
    var(--section-periwinkle-grey-color, var(--periwinkle-grey));

  .value {
    color: var(--section-ebony-color, var(--ebony));
  }

  .impact-percent {
    color: var(--section-ebony-color, var(--ebony));
    font-size: 15px;
    font-weight: 600;
  }

  @media (max-width: 760px) {
    gap: 8px;
    grid-template-columns: 20% repeat(5, 1fr);
  }
`;

export const Item = styled.div`
  font-size: 15px;
  color: var(--section-slate-color, var(--slate));
  &:first-letter {
    text-transform: uppercase;
  }

  padding: 12px 0 12px 0;
  font-weight: 400;
`;

export const ImpactTitle = styled(Item)`
  font-size: 13px;
  font-weight: 600;
  color: var(--section-ebony-color, var(--ebony));
`;

export const ItemTitle = styled(ImpactTitle)`
  color: var(--section-slate-color, var(--slate));
`;

export const UrlTitle = styled(ImpactTitle)`
  color: var(--section-slate-color, var(--slate));
  white-space: nowrap;
  flex: 5;
`;
